export const getPageType = (page: Record<string, any>) => {
  const { t } = useNuxtApp().$i18n;

  if (page.url === t('url.homepage')) {
    return 'homepage';
  }

  if (page.url.startsWith('/p/')) {
    return 'product';
  }

  if (page.content.template === 'category') {
    return 'category';
  }

  if (page.content.template === 'brand-overview' || page.url.startsWith(t('url.brand'))) {
    return 'brand category';
  }

  if (page.content.template === 'search' || page.url.startsWith(t('url.search'))) {
    return 'searchresult';
  }

  if (page.content.template === 'product-listing') {
    return 'productlist';
  }

  if (page.content.template === 'cart') {
    return 'cart';
  }

  if (page.content.template === 'order-confirmation') {
    return 'confirmation';
  }

  if (
    page.url === t('url.legal.imprint') ||
    page.url === t('url.legal.terms') ||
    page.url === t('url.legal.dataPrivacy') ||
    page.url === t('url.legal.recallAllocation')
  ) {
    return 'legal';
  }

  if (page.url === t('url.checkout.index')) {
    return 'checkout';
  }

  if (page.url === t('url.checkout.address')) {
    return 'checkoutaddress';
  }

  if (page.url === t('url.checkout.confirmation')) {
    return 'confirmation';
  }

  if (page.url === t('url.checkout.delivery')) {
    return 'checkoutdelivery';
  }

  if (page.url === t('url.checkout.login')) {
    return 'checkout';
  }

  if (page.url === t('url.checkout.payment')) {
    return 'checkoutpayment';
  }

  if (page.url === t('url.checkout.summary')) {
    return 'checkoutsummary';
  }

  if (page.url === t('url.stores.index')) {
    return 'storefinder';
  }

  if (page.url === t('url.stores.detail') || page.content.template === 'store-detail') {
    return 'store detail page';
  }

  if (page.url === t('url.newsletter') || page.url === t('url.account.newsletter')) {
    return 'newsletter';
  }

  if (page.url === t('url.newsletterPublicPreferences')) {
    return 'newsletter preferences';
  }

  if (page.url === t('url.newsletterPublicUnsubscribe')) {
    return 'newsletter unsubscribe';
  }

  if (page.url === t('url.registration')) {
    return 'register';
  }

  if (
    page.url === t('url.password.confirmation') ||
    page.url === t('url.password.expired') ||
    page.url === t('url.password.request') ||
    page.url === t('url.password.reset')
  ) {
    return 'password';
  }

  if (
    page.url === t('url.account.helpContact') ||
    page.url === t('url.account.helpContactConfirmation') ||
    page.url.startsWith(t('url.faqPage'))
  ) {
    return 'help';
  }

  if (page.url.startsWith(t('url.account.index'))) {
    return 'my_account';
  }

  if (page.url.startsWith(t('url.magazine')) || page.url.startsWith('/tierischengagiert/')) {
    return 'content';
  }

  if (page.url.startsWith('/servicewelt/') || page.url.startsWith(t('/domain-de-service/'))) {
    return 'service world';
  }

  if (page.url.startsWith('/service')) {
    return 'service';
  }

  return null;
};

export const getPagePath = (page: Record<string, any>) => {
  if (!page.content.breadcrumbs.length) {
    return [];
  }

  return Array.from(page.content.breadcrumbs, (breadcrumb: Record<string, any>) => breadcrumb.title);
};

export const getPageCategory = (page: Record<string, any>) => {
  const pageType = getPageType(page);

  if (pageType !== 'product' && pageType !== 'productlist') {
    return null;
  }

  if (!page.content.breadcrumbs.length) {
    return null;
  }

  return page.content.breadcrumbs[0].title;
};
